class CrossSellSlider extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-cross-sell-scroller]');
    this.dots = Array.from(this.querySelectorAll('[data-cross-sell-dot]'));

    if (!this.scroller || this.dots.length < 2) return;

    this.updateActiveDot = this.updateActiveDot.bind(this);
    this.handleScroll = () => window.requestAnimationFrame(this.updateActiveDot);
    this.handleDotClick = this.handleDotClick.bind(this);

    this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
    this.dots.forEach((dot) => dot.addEventListener('click', this.handleDotClick));

    this.resizeObserver = new ResizeObserver(this.updateActiveDot);
    this.resizeObserver.observe(this.scroller);
    this.updateActiveDot();
  }

  disconnectedCallback() {
    if (!this.scroller || !this.dots) return;

    this.scroller.removeEventListener('scroll', this.handleScroll);
    this.dots.forEach((dot) => dot.removeEventListener('click', this.handleDotClick));
    this.resizeObserver?.disconnect();
  }

  handleDotClick(event) {
    const index = Number(event.currentTarget.dataset.crossSellDot);
    const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
    const left = this.dots.length > 1 ? maxScroll * (index / (this.dots.length - 1)) : 0;

    this.scroller.scrollTo({ left, behavior: 'smooth' });
  }

  updateActiveDot() {
    const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
    const progress = maxScroll > 0 ? this.scroller.scrollLeft / maxScroll : 0;
    const activeIndex = Math.min(this.dots.length - 1, Math.round(progress * (this.dots.length - 1)));

    this.dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }
}

if (!customElements.get('cross-sell-slider')) {
  customElements.define('cross-sell-slider', CrossSellSlider);
}
